/**
 * AI 助手模块 - 中文翻译
 */
export const aiAssistantZh = {
  // 通用
  title: 'AI 助手',
  description: '智能问答助手，帮您解答 IT、HR、行政等问题',
  
  // 悬浮按钮
  fab: {
    tooltip: 'AI 助手',
    open: '打开助手',
    close: '关闭助手',
  },

  // 对话框
  chat: {
    title: 'AI 助手',
    placeholder: '输入您的问题...',
    send: '发送',
    sending: '发送中...',
    newChat: '新建对话',
    history: '历史记录',
    thinking: 'AI 正在思考...',
    error: '抱歉，发生了错误，请重试',
    retry: '重试',
    empty: '开始新对话，输入您的问题',
    welcome: '您好！我是企业智能助手，可以帮您解答 IT、HR、行政等方面的问题。请问有什么可以帮助您的？',
    disclaimer: '* AI 仅提供参考建议，不执行任何系统操作',
  },

  // 消息
  message: {
    you: '您',
    assistant: 'AI 助手',
    system: '系统',
    copied: '已复制到剪贴板',
    copy: '复制',
    regenerate: '重新生成',
  },

  // 反馈
  feedback: {
    helpful: '有帮助',
    notHelpful: '没帮助',
    thanks: '感谢您的反馈！',
    addComment: '添加评论（可选）',
    submit: '提交反馈',
    submitted: '反馈已提交',
  },

  // 升级工单
  escalate: {
    button: '转人工',
    title: '转人工服务',
    description: '确认将问题升级给人工客服？',
    confirm: '确认转人工',
    cancel: '取消',
    category: '问题分类',
    priority: '优先级',
    additionalInfo: '补充说明',
    additionalInfoPlaceholder: '请补充更多问题详情（可选）',
    success: '已成功创建工单，相关团队会尽快与您联系',
    ticketNumber: '工单号',
    categories: {
      IT: 'IT 支持',
      HR: '人力资源',
      ADMIN: '行政服务',
      FINANCE: '财务问题',
      OTHER: '其他',
    },
    priorities: {
      LOW: '低',
      MEDIUM: '中',
      HIGH: '高',
      URGENT: '紧急',
    },
  },

  // 知识纠正
  knowledgeFix: {
    button: '答案有误',
    title: '纠正回答',
    description: '如果 AI 的回答不准确，请提供正确答案',
    correctAnswer: '正确答案',
    correctAnswerPlaceholder: '请输入正确的回答内容...',
    submit: '提交纠正',
    success: '感谢您的贡献！您的纠正已提交审核',
    cancel: '取消',
  },

  // 历史对话
  history: {
    title: '历史对话',
    empty: '暂无历史对话',
    loadMore: '加载更多',
    delete: '删除',
    deleteConfirm: '确定删除这个对话吗？',
    deleted: '对话已删除',
    today: '今天',
    yesterday: '昨天',
    earlier: '更早',
    searchPlaceholder: '搜索对话...',
  },

  // 对话状态
  status: {
    ACTIVE: '进行中',
    CLOSED: '已关闭',
    ESCALATED: '已升级',
  },

  // 分类
  categories: {
    GENERAL: '通用咨询',
    IT: 'IT 支持',
    HR: '人力资源',
    ADMIN: '行政服务',
    FINANCE: '财务问题',
  },

  // 管理后台
  admin: {
    title: 'AI 助手管理',
    dashboard: '仪表盘',
    prompts: 'Prompt 管理',
    tickets: '工单管理',
    knowledge: '知识库管理',
    config: '系统配置',
    stats: '统计分析',
  },

  // 仪表盘
  dashboard: {
    title: 'AI 助手仪表盘',
    callsLast24h: '24小时调用量',
    callsLast7d: '7天调用量',
    successRate: '成功率',
    avgResponseTime: '平均响应时间',
    categoryDistribution: '场景分布',
    satisfactionRate: '满意度',
    hallucinations: '幻觉标记数',
    pendingTickets: '待处理工单',
    seconds: '秒',
  },

  // Prompt 管理
  prompts: {
    title: 'Prompt 模板管理',
    description: '管理不同场景的提示词模板',
    create: '创建模板',
    edit: '编辑模板',
    name: '模板名称',
    category: '适用分类',
    content: '模板内容',
    version: '版本',
    status: '状态',
    active: '已激活',
    inactive: '未激活',
    activate: '激活',
    preview: '预览',
    save: '保存',
    delete: '删除',
    deleteConfirm: '确定删除这个模板吗？',
    emptyTitle: '暂无模板',
    emptyDesc: '请先创建提示词模板',
    dialogCreateTitle: '创建模板',
    dialogEditTitle: '编辑模板',
    namePlaceholder: '请输入模板名称',
    contentPlaceholder: '请输入系统提示词内容...',
    cancel: '取消',
    actions: '操作',
    activateAction: '激活',
    editAction: '编辑',
    deleteAction: '删除',
  },

  // 工单管理
  tickets: {
    title: '工单管理',
    id: '工单号',
    category: '分类',
    priority: '优先级',
    status: '状态',
    assignee: '处理人',
    createdAt: '创建时间',
    actions: '操作',
    view: '查看',
    assign: '分配',
    resolve: '解决',
    resolution: '解决方案',
    resolutionPlaceholder: '请输入解决方案...',
    statuses: {
      PENDING: '待处理',
      IN_PROGRESS: '处理中',
      RESOLVED: '已解决',
      CLOSED: '已关闭',
    },
  },

  // 知识库
  knowledge: {
    title: '知识纠正管理',
    description: '审核用户提交的知识纠正内容',
    originalAnswer: '原始回答',
    correctAnswer: '正确答案',
    contributor: '贡献者',
    status: '状态',
    reviewNote: '审核备注',
    approve: '通过',
    reject: '拒绝',
    view: '查看',
    createdAt: '创建时间',
    filterAll: '全部',
    emptyTitle: '暂无纠正记录',
    emptyDesc: '当前没有待审核的纠正内容',
    dialogTitle: '知识纠正详情',
    close: '关闭',
    reviewNoteOptional: '审核备注（可选）',
    reviewNotePlaceholder: '请输入审核备注...',
    statuses: {
      PENDING: '待审核',
      APPROVED: '已通过',
      REJECTED: '已拒绝',
    },
  },

  // 统计
  stats: {
    title: '使用统计',
    overview: '概览',
    feedback: '反馈分析',
    hallucinations: '幻觉分析',
    dateRange: '时间范围',
    totalConversations: '总对话数',
    totalMessages: '总消息数',
    totalTickets: '工单数',
    resolutionRate: '解决率',
    satisfactionScore: '满意度评分',
    likes: '点赞数',
    dislikes: '点踩数',
    likeRate: '好评率',
  },

  // 配置
  config: {
    title: '系统配置',
    pageDescription: '配置 AI 助手的行为与限制',
    key: '配置项',
    value: '配置值',
    description: '说明',
    save: '保存',
    saved: '配置已保存',
    emptyTitle: '暂无配置项',
    emptyDesc: '当前没有可编辑的配置',
    actions: '操作',
    edit: '编辑',
    cancel: '取消',
    descriptions: {
      max_tokens: '单次响应的最大 token 数',
      temperature: '回答创意程度（0-1）',
      model: '使用的模型',
      rate_limit: '每用户每分钟请求上限',
      max_context_messages: '上下文最大消息数',
      enable_streaming: '是否启用流式输出',
      enable_pii_detection: '是否启用隐私信息识别与脱敏',
      enable_prompt_guard: '是否启用提示词注入防护',
    },
  },

  // 错误消息
  errors: {
    conversationNotFound: '对话不存在',
    messageTooLong: '消息内容过长',
    rateLimit: '请求过于频繁，请稍后再试',
    serviceUnavailable: '服务暂时不可用，请稍后重试',
    networkError: '网络错误，请检查网络连接',
  },
};

export default aiAssistantZh;
